export * from './notification.component';

import { NotificationComponent } from './notification.component';

export const UI_NOTIFICATION = [NotificationComponent] as const;
